require('./stepsView.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
const formActions = require('react-redux-form').actions;
const suitabilityActions = require('actions/RASuitabilityTest');
// @ components
const RAModal = require('components/RAComponents/commons/RAModal/RAModal');
const RANetworthPercentageSlider = require('../../commons/RANetworthPercentageSlider/RANetworthPercentageSlider');
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;
// @ utilities
import { formatText } from 'core/i18n';

const UtagHelper = require('utilities/utagHelper');
// @ constants
const { PATH_GBI_TI, PATH_ROBO_TI } = require('constants/uTagConstants/paths');
const {
    SUITABILITY_TEST_PROFILE_MODEL_ANSWERS,
} = require('constants/RAConstants/index');
const {
    TEST_PROCESS_STEP_STEP_9,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_QUESTION_LOAD,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_BUTTON_NEXT,
} = require('constants/uTagConstants/RAConstants');
const { ROBO } = require('constants/userProfile');

class RAPercentageInvestmentComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.onHandleContinueButton = this.onHandleContinueButton.bind(this);
        this.onHandlePrevButton = this.onHandlePrevButton.bind(this);
        this.onSliderValueChange = this.onSliderValueChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        this.recordEvent(EVENT_DETAIL_QUESTION_LOAD);
    }

    onHandleContinueButton() {
        const { RATestWizard, raTestActions, userProfile, immSuitabilityTest } = this.props;
        const step = RATestWizard.currentStep;
        const substep = RATestWizard.currentSubStep;
        const { lastSubStep } = RATestWizard;
        const finalized = RATestWizard.steps?.[step].steps?.[substep].finished;
        const data = {
            step,
            substep,
        };

        const immQuestions = immSuitabilityTest.get('questions');
        const capitalRatioList = immQuestions.getIn(['322', 'answers']).toJS();
        const questionID = RATestWizard.steps?.[step].steps?.[substep].question;

        const answerValue = userProfile?.RASuitabilityTest?.answers?.[questionID];
        const answerData = capitalRatioList.find(value => value.id === answerValue);
        const eventValue = `${EVENT_DETAIL_BUTTON_NEXT}, ${answerData.label}`;

        if (!this.hasSelectedOption()) {
            this.setState({ showModal: true });
        } else if (finalized) {
            raTestActions.nextStep(data);
        } else if (lastSubStep) {
            raTestActions.finishStep(data);
        } else {
            raTestActions.finishSubStep(data);
        }

        this.recordEvent(eventValue);
    }

    onHandlePrevButton() {
        const { RATestWizard, raTestActions } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const data = {
            currentStep,
            currentSubStep,
        };

        raTestActions.prevStep(data);
        this.recordEvent(EVENT_DETAIL_BUTTON_PREV);
    }

    onSliderValueChange(value) {
        const { formActions, RATestWizard, suitabilityActions } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionId = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionId}`, value);
        suitabilityActions.updateCapitalRatioOption(value);
    }

    hasSelectedOption() {
        const { RATestWizard, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        return !!userProfile?.RASuitabilityTest?.answers?.[questionID];
    }

    recordEvent = (eventDetail = '', eventCategory = EVENT_CATEGORY_SUITABILITY_TEST) => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        UtagHelper.recordEventRoboGBI(pathForTag, eventCategory, TEST_PROCESS_STEP_STEP_9, eventDetail, userProfile);
    };

    recordEventSliderChange = value => {
        this.recordEvent(value);
    };

    recordEventTooltipClick = () => {
        this.recordEvent(EVENT_DETAIL_TOOLTIP);
    };

    toggleModal() {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    }

    getContent() {
        const { immSuitabilityTest } = this.props;
        const immAnswers = immSuitabilityTest.get('answers');
        const immQuestions = immSuitabilityTest.get('questions');
        const capitalRatioSO = immAnswers.get('322');
        const capitalRatioTitle = immQuestions.getIn(['322', 'title']);
        const capitalRatioList = immQuestions.getIn(['322', 'answers']).toJS();

        return (
            <RANetworthPercentageSlider
                value={capitalRatioSO}
                titleText={capitalRatioTitle}
                steps={capitalRatioList}
                changeSelectedOption={this.onSliderValueChange}
                tooltipContent={formatText('suitabilityTest-tooltipNineQuestion')}
                disabled={false}
                recordEventSliderChange={this.recordEventSliderChange}
                recordEventTooltipClick={this.recordEventTooltipClick}
            />
        );
    }

    getModalProps() {
        const { raTestActions } = this.props;

        return {
            show: this.state.showModal,
            hide: this.toggleModal,
            title: formatText('raModal-percentageInvestmentModalTitle'),
            text: formatText('raModal-percentageInvestmentModal'),
            firstButton: formatText('raModal-continueButton'),
            firstAction: () =>
                raTestActions.nextStep({
                    step: 2,
                    substep: 2,
                }),
            secondButton: formatText('raModal-reconsiderButton'),
            secondAction: this.toggleModal,
        };
    }

    render() {
        const { userProfile, RATestWizard } = this.props;

        const content = this.getContent();
        const modalProps = this.getModalProps();
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        const disabled = !userProfile.RASuitabilityTest.answers[questionID];

        return (
            <div>
                <div className="steps-view">
                    {content}
                    <RAModal {...modalProps} />
                </div>
                <hr />
                <div className="steps-view__footer">
                    <RoadmapNavigation
                        buttonContinueType="submit"
                        buttonContinueAction={this.onHandleContinueButton}
                        buttonContinueText={formatText('suitabilityTest-next')}
                        buttonPrevText={formatText('suitabilityTest-prev')}
                        buttonCancelText={formatText('suitabilityTest-getOut')}
                        buttonPrevAction={this.onHandlePrevButton}
                        buttonContinueDisabled={disabled}
                    />
                </div>
            </div>
        );
    }
}

export const RAPercentageInvestment = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        raTestActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        suitabilityActions: bindActionCreators(suitabilityActions, dispatch),
    })
)(RAPercentageInvestmentComponent);
